module.exports = [{
      plugin: require('C:/Users/Nico/Documents/business/wipek/lck/repo/prepaid-card-registration-page/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/Nico/Documents/business/wipek/lck/repo/prepaid-card-registration-page/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
